import type { GrowthPackDefinition } from '../../../domain/industry/types';
import { buildPack, PACK_CONTENT } from './packBuilder';

const growthPacks: GrowthPackDefinition[] = [
  {
    id: 'edtech_growth_starter',
    industryId: 'edtech',
    tier: 1,
    name: 'LMS Launch',
    description: 'Student privacy and LMS fundamentals.',
    unlocks: {
      missionIds: ['ed_mission_privacy'],
      productIds: ['ed_lms'],
    },
  },
  {
    id: 'edtech_growth_access',
    industryId: 'edtech',
    tier: 2,
    name: 'Accessibility',
    description: 'WCAG-focused tooling after FERPA baseline.',
    unlockConditions: { completedMissionIds: ['ed_mission_privacy'] },
    unlocks: {
      missionIds: ['ed_mission_accessibility'],
      productIds: ['ed_assessment', 'ed_virtual_class'],
    },
  },
  {
    id: 'edtech_growth_career',
    industryId: 'edtech',
    tier: 3,
    name: 'Career Pathways',
    description: 'Skills and career readiness after accessibility compliance.',
    unlockConditions: { completedMissionIds: ['ed_mission_accessibility'], minCompliance: 60 },
    unlocks: {
      productIds: ['ed_career'],
    },
  },
];

export const edtechPack = buildPack({
  id: 'edtech',
  ...PACK_CONTENT.edtech,
  growthPacks,
  expansionPacks: [
    {
      id: 'edtech_exp_global',
      industryId: 'edtech',
      name: 'Global Campus',
      version: '1.0.0',
      description: 'GDPR and COPPA framework bundle for international student data.',
      requiresGrowthTierId: 'edtech_growth_access',
      // Framework ids added when edtech entries land in REGULATORY_FRAMEWORKS
      adds: {},
    },
  ],
});